module.exports = __webpack_public_path__ + "img/适宜度.4f342946.png";